import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from '@app/pages/login/login.component';
import { RoleGuard } from './guards/role.guard';
import { AdminLayoutComponent } from './pages/admin/admin-layout/admin-layout.component';
import { SMEDashboardComponent } from './pages/SME/smedashboard/smedashboard.component';
import { AdminUserManagementComponent } from '@app/pages/admin/admin-user-management/admin-user-management.component';
import { ManageProjectsComponent } from './pages/admin/admin-manage-projects/admin-manage-projects.component';
import { ManageCustomersComponent } from './pages/admin/admin-manage-customers/admin-manage-customers.component';
import { ManageLanguagesComponent } from './pages/admin/admin-manage-languages/admin-manage-languages.component';
import { DesignerLayoutComponent } from '@app/pages/designer/designer-layout/designer-layout.component';
import { TemplateListComponent } from './pages/designer/template-list/template-list.component';
import { TemplateFormComponent } from './pages/designer/template-form/template-form.component';
import { PropertyEditorComponent } from './pages/designer/property-editor/property-editor.component';
import { LayoutListComponent } from './pages/designer/layout-list/layout-list.component';
import { LayoutFormComponent } from './pages/designer/layout-form/layout-form.component';
import { LayoutLinesComponent } from './pages/designer/layout-lines/layout-lines.component';
import { ObjectGroupListComponent } from './pages/designer/object-group-list/object-group-list.component';
import { ObjectGroupFormComponent } from './pages/designer/object-group-form/object-group-form.component';
import { ObjectGroupLinesComponent } from './pages/designer/object-group-lines/object-group-lines.component';
import { SlideTypeLinesComponent } from './pages/designer/slide-type-lines/slide-type-lines.component';
import { SlideTypeListComponent } from './pages/designer/slide-type-list/slide-type-list.component';
import { SlideTypeFormComponent } from './pages/designer/slide-type-form/slide-type-form.component';
import { ProjectParametersComponent } from './pages/admin/project-parameters/project-parameters.component';
import { AdminServiceCreditsComponent } from './pages/admin/admin-service-credits/admin-service-credits.component';
import { CreatorLayoutComponent } from './pages/creator/creator-layout/creator-layout.component';
import { ProjectListComponent } from './pages/creator/project-list/project-list.component';
import { ProjectSlidesComponent } from './pages/creator/project-slides/project-slides.component';
import { SlidelinesComponent } from './pages/creator/slidelines/slidelines.component';
import { ProjectFromLessonComponent } from './pages/creator/project-from-lesson/project-from-lesson.component';
import { AudioGenComponent } from './pages/creator/audio-gen/audio-gen.component';
import { LessonExcelImportComponent } from './pages/creator/lesson-excel-import/lesson-excel-import.component';
import { LessonMetaComponent } from './pages/SME/lesson-meta/lesson-meta.component';
import { TOCEditorComponent } from './pages/SME/toceditor/toceditor.component';
import { SMELayoutComponent } from './pages/SME/sme-layout/sme-layout.component';
import { LessonSlideEditorComponent } from './pages/SME/lesson-slide-editor/lesson-slide-editor.component';
import { SMEChatComponent } from './pages/SME/sme-chat/sme-chat.component';
import { SMEHelpGuideComponent } from './pages/SME/sme-help-guide/sme-help-guide.component';


const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    children: [
      { path: 'user-management', component: AdminUserManagementComponent },
      { path: 'project-management', component: ManageProjectsComponent },
      { path: 'project-from-lesson', component: ProjectFromLessonComponent },
      { path: 'customer-management', component: ManageCustomersComponent },
      { path: 'language-management', component: ManageLanguagesComponent },
      { path: 'service-credits', component: AdminServiceCreditsComponent },
      { path: 'project-parameters/:shortcode', component: ProjectParametersComponent },
      { path: 'lesson-excel-import', component: LessonExcelImportComponent },
      { path: '', redirectTo: 'user-management', pathMatch: 'full' }
    ]
  },
  {
    path: 'SME',
    component: SMELayoutComponent,
    children: [
      { path: 'chat', component: SMEChatComponent },
      { path: 'help', component: SMEHelpGuideComponent },
      { path: 'dashboard', component: SMEDashboardComponent },
      { path: 'lesson/new/userid/:userid', component: LessonMetaComponent },
      { path: 'lesson/meta/lessonid/:lessonid', component: LessonMetaComponent },
      { path: 'lesson/toc/lessonid/:lessonid', component: TOCEditorComponent },
      { path: 'lesson/lessonSlide/lessonid/:lessonid/slideid/:slideid/slideTitle/:slideTitle', component: LessonSlideEditorComponent },
      { path: 'lesson/generateppt/lessonid/:lessonid/pptType/:pptType', component: LessonMetaComponent },
      { path: '', redirectTo: 'chat', pathMatch: 'full' }
      // { path: 'lesson/:id/content/:tocId', component: ContentEditorComponent }
    ]
  },

  {
    path: 'creator',
    component: CreatorLayoutComponent,
    children: [
      { path: 'project-list', component: ProjectListComponent },
      { path: 'project-from-lesson', component: ProjectFromLessonComponent },
      { path: 'audio-gen', component: AudioGenComponent },
      { path: 'lesson-excel-import', component: LessonExcelImportComponent },
      { path: 'project-slides/:shortcode', component: ProjectSlidesComponent },
      { path: 'slidelines/projects/:projectId/slides/:slideId', component: SlidelinesComponent },
      { path: '', redirectTo: 'project-list', pathMatch: 'full' }
    ]
  },
  {
    path: 'designer',
    component: DesignerLayoutComponent,
    children: [

      { path: 'template-list', component: TemplateListComponent },
      { path: 'template-form', component: TemplateFormComponent },
      { path: 'property-editor/:shortcode', component: PropertyEditorComponent },
      { path: 'layout-list', component: LayoutListComponent },
      { path: 'layout-form', component: LayoutFormComponent },
      { path: 'layout-lines/:id', component: LayoutLinesComponent },
      { path: 'object-group-list', component: ObjectGroupListComponent },
      { path: 'object-group-form', component: ObjectGroupFormComponent },
      { path: 'object-group-lines/:objGroupShortcode', component: ObjectGroupLinesComponent },
      { path: 'slide-type-list', component: SlideTypeListComponent },
      { path: 'slide-type-form', component: SlideTypeFormComponent },
      { path: 'slide-type-lines/:slideTypeShortcode', component: SlideTypeLinesComponent },

      //      { path: 'project-management', component: ManageProjectsComponent },
      { path: '', redirectTo: 'template-list', pathMatch: 'full' }
    ]
  }
  //{ path: 'creator', component: CreatorDashboardComponent, canActivate: [RoleGuard], data: { roles: ['creator'] } },
  //  { path: 'admin/users', component: AdminUserManagementComponent, canActivate: [RoleGuard], data: { roles: ['admin'] } }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
